module.exports = __webpack_public_path__ + "static/media/attachment.d2eec69d.svg";